export const PromiseSerial = (functionArray) => {
  return functionArray.reduce(
    (promise, functionEach) =>
      promise.then((result) =>
        functionEach().then(Array.prototype.concat.bind(result))
      ),
    Promise.resolve([])
  );
};
